import { api } from 'src/api/axios';

export interface GroupSettingsPayload {
  texts?: {
    welcomeText?: string;
    welcomeTitle?: string;
  };
  images?: {
    logo?: string;
    welcome?: string;
    emailHeader?: string;
    emailFooter?: string;
  };
  emails?: {
    primary?: string;
    secondary?: string;
    tertiary?: string;
  };
  phones?: {
    primary?: string;
    secondary?: string;
    tertiary?: string;
  };
  colors?: {
    primary?: string;
    secondary?: string;
    tertiary?: string;
    quaternary?: string;
    quinary?: string;
    senary?: string;
    septenary?: string;
    octonary?: string;
    nonary?: string;
    denary?: string;
  } | string; // Some GET payloads show colors as string; accept both for flexibility
}

export interface GroupPayload {
  name?: string;
  description?: string;
  host?: string;
  status?: number;
  type?: number;
  settings?: GroupSettingsPayload;
}

export interface GroupResponse {
  id: unknown;
  createdAt: string;
  updatedAt: string;
  name: string;
  description: string;
  host: string;
  status: number;
  type: number;
  settings?: GroupSettingsPayload;
}

export interface GroupListResponse {
  data: GroupResponse[];
  pagination: {
    hasNextPage: boolean;
    total: number;
    limit: number;
  };
}

export const groupsService = {
  getOne: async (id: string | number): Promise<GroupResponse> => {
    const res = await api.get(`/groups/${id}`);
    return res.data;
  },
  update: async (id: string | number, payload: GroupPayload): Promise<GroupResponse> => {
    const res = await api.patch(`/groups/${id}`, payload);
    return res.data;
  },
  remove: async (id: string | number): Promise<void> => {
    await api.delete(`/groups/${id}`);
  },
  getList: async (search?: string): Promise<GroupListResponse> => {
    const params = search ? { search } : {};
    const res = await api.get('/groups', { params });
    return res.data;
  },
  create: async (payload: GroupPayload): Promise<GroupResponse> => {
    const res = await api.post('/groups', payload);
    return res.data;
  },
  uploadImage: async (id: string | number, file: File, imageName: 'logo' | 'welcome' | 'emailHeader' | 'emailFooter'): Promise<GroupResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', imageName);
    
    const res = await api.post(`/groups/${id}/settings/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },
};


